import React, { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";

import { Space, Table, Typography } from "antd";
import styled from "styled-components";

import { useParams } from "react-router-dom";
import { PaginationComponent } from "../../Common/Pagination/PaginationComponent";
import SearchFilter from "~components/SearchFilter/SearchFilter";
import { useHandlePagination } from "../../hooks/useHandlePagination";
import { useHttp } from "../../hooks/useHttp";
import { getColumns } from "./columnsRepository";

const TableToolbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-content: center;
`;

const defaultPagination = 1000;

const SeasonTeamImages = () => {
  const { formatMessage } = useIntl();
  const [searchText, setSearchText] = useState("");
  const [paginationString] = useState(`limit=${defaultPagination}&offset=0`);
  const [filteredData, setFilteredData] = useState([]);

  const { request, loading } = useHttp();
  const { sport, organizationId, seasonId, customerId } = useParams();
  const [data, setData] = useState([]);

  const fetchImages = useCallback(async () => {
    await request({
      url: `/v1/${sport}/o/${organizationId}/seasons/${seasonId}/entities?include=organizations,entities,seasons&${paginationString}`,
    }).then((res) => {
      if (res) {
        setData(res);
      }
    });
  }, [paginationString, request, sport, organizationId, seasonId]);

  useEffect(() => {
    fetchImages();
  }, [fetchImages]);

  useEffect(() => {
    if (data) {
      let filteredData = data.data ? data.data : [];

      filteredData.forEach((result, index) => {
        filteredData[index] = {
          ...result,
          ...data.includes?.resources?.entities?.[result.entity.id],
        };
        filteredData[index].status = result.status;
      });

      if (searchText !== "") {
        filteredData = filteredData.filter((result) => {
          return result.nameFullLocal.toUpperCase().indexOf(searchText.toUpperCase()) > -1;
        });
      }

      setFilteredData(filteredData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(data), searchText]);

  const { pageSize, currentPage, handlePaginationChange } = useHandlePagination();

  const columns = getColumns({
    formatMessage,
    customerId: customerId,
    sport: sport,
  });

  return (
    <React.Fragment>
      <>
        <Space direction="vertical" style={{ width: "100%" }}>
          <TableToolbar>
            <Typography.Title level={4}>
              {formatMessage({
                id: "team.images",
                defaultMessage: "Team Images",
              })}
            </Typography.Title>
            <SearchFilter doSearch={setSearchText} />
          </TableToolbar>
          <Table
            loading={loading}
            columns={columns}
            dataSource={filteredData}
            size="small"
            pagination={{
              current: currentPage,
              defaultPageSize: pageSize,
              showSizeChanger: true,
              showQuickJumper: true,
              position: ["bottomCenter"],
              total: filteredData?.length || 0,
              onChange: handlePaginationChange,
              showTotal: (total, range) => <PaginationComponent pageSize={pageSize} total={total} range={range} />,
            }}
            rowKey={(x) => x.entityId}
          />
        </Space>
      </>
    </React.Fragment>
  );
};

export default SeasonTeamImages;
